import { Component } from '@angular/core';

@Component({
  selector: 'icon-underway-campaign',
  templateUrl: './icon-underway-campaign.component.html',
  styleUrls: ['./icon-underway-campaign.component.scss']
})
export class IconUnderwayCampaignComponent {}
